<script setup lang="ts">
import type { Profile } from '@/stores/appStore'
import { computed, type PropType } from 'vue'

const profiles = defineModel('profiles', { required: true, type: Array as PropType<Profile[]> })
const { maxView, compact } = defineProps<{ maxView: null | number; compact: boolean }>()
const selectedProfiles = computed(() => {
  return maxView ? profiles.value.slice(0, maxView) : profiles.value
})
</script>

<template>
  <div v-if="profiles.length === 0" class="full-width column items-center q-pa-xl">
    <q-icon name="mdi-account-group" color="secondary" size="4rem" />
    <div class="text-center q-mt-md">
      <div class="text-h5 text-secondary text-weight-bold q-mb-sm">No Profiles Yet</div>
      <div class="text-subtitle1 text-grey-7">
        Get ready for something amazing! Soon this space will be filled with awesome profiles of people you are meeting
        with.
      </div>
    </div>
  </div>
  <div v-else class="row q-col-gutter-md full-width">
    <div
      class="col-12 col-sm-6 col-md paddingFixer4th"
      v-for="(profile, index) in selectedProfiles"
      :key="profile.personID"
      style="min-width: 23%"
    >
      <div class="myCard q-pa-md full-height">
        <a :href="`/event/${profile.eventID}/person/${profile.personID}`" style="display: block">
          <q-tooltip>{{ profile.Person.email }}</q-tooltip>
          <div class="row justify-center">
            <q-avatar
              class="q-mb-md"
              :size="compact ? '80px' : '96px'"
              :color="index % 2 === 0 ? 'secondary' : 'accent'"
              style="display: block"
            >
              <img v-if="profile.Person.profilePicutre" :src="profile.Person.profilePicutre" />
              <q-icon v-else name="mdi-account-tie" />
            </q-avatar>
          </div>
          <p class="text-bold text-subtitle1 text-white text-truncate text-center">
            {{
              profile.Person.firstName ? `${profile.Person.firstName} ${profile.Person.lastName}` : profile.Person.email
            }}
          </p>
          <p class="text-bold text-grey-6 text-center text-truncate">{{ profile.Person.jobTitle }}</p>
          <p class="text-grey-6 text-center">{{ profile.Person.companyName ?? 'Unknown' }}</p>
          <div v-if="!compact" class="row justify-center">
            <a
              v-if="profile.Person.linkedinUsername"
              :href="`https://www.linkedin.com/in/${profile.Person.linkedinUsername}`"
              target="_blank"
            >
              <q-icon size="sm" name="mdi-linkedin" class="text-grey-6" />
            </a>
            <a :href="`mailto:${profile.Person.email}`" target="_blank">
              <q-icon size="sm" name="mdi-email" class="text-grey-6" />
            </a>
          </div>
          <p v-if="!compact" class="text-grey-6 text-center q-pt-md">View Profile</p>
        </a>
      </div>
    </div>
  </div>
</template>

<style scoped>
p {
  margin: 0;
}
</style>
